/**
 * @file
 * @fileOverview This file contains the ImageProcessor class for processing images.
 * @version 1.0.0
 * @author Parker Eli Bidigare
 * @date 2024-05-26
 */

class ImageProcessor {
  constructor(base64ImageData, drawData, aPlaneId) {
    this.base64ImageData = base64ImageData;
    this.drawData = drawData;
    this.aPlaneId = aPlaneId;
    this.canvas = document.createElement('canvas');
    this.img = new Image();
  }

  decodeBase64Image(base64) {
    return base64;
  }

  encodeImageToBase64(can) {
    return can.toDataURL('image/png');
  }

  setBase64Data(data) {
    this.base64ImageData = data;
  }

  setDrawData(data) {
    this.drawData = data;
  }

  getBase64Data() {
    return this.base64ImageData;
  }

  getDrawData() {
    return this.drawData;
  }

  getAPlaneId() {
    return this.aPlaneId;
  }

  drawShapesOnImage(imageSrc, drawData, callback) {
    this.img.onload = () => {
      const ctx = this.canvas.getContext('2d');
      this.canvas.width = this.img.width;
      this.canvas.height = this.img.height;
      ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
      ctx.drawImage(this.img, 0, 0);

      drawData.forEach((item) => {
        ctx.strokeStyle = item.color || 'red';
        ctx.fillStyle = item.color || 'red';
        ctx.lineWidth = item.lineWidth || 2;

        switch (item.type) {
          case 'rectangle':
            ctx.strokeRect(item.x, item.y, item.width, item.height);
            if (item.label) {
              ctx.font = `${item.fontSize || 16}px Arial`;
              ctx.fillText(
                item.label,
                item.x,
                item.y + item.height + (item.fontSize || 16)
              );
            }
            break;
          case 'text':
            ctx.font = `${item.fontSize}px Arial`;
            ctx.fillText(item.text, item.x, item.y);
            break;
          case 'circle':
            ctx.beginPath();
            ctx.arc(item.x, item.y, item.radius, 0, 2 * Math.PI);
            ctx.stroke();
            break;
          case 'line':
            ctx.beginPath();
            ctx.moveTo(item.x1, item.y1);
            ctx.lineTo(item.x2, item.y2);
            ctx.stroke();
            break;
        }
      });

      const base64Image = this.encodeImageToBase64(this.canvas);
      callback(base64Image);
    };

    this.img.src = imageSrc;
  }

  processImage() {
    const imageSrc = this.decodeBase64Image(this.base64ImageData);
    this.drawShapesOnImage(imageSrc, this.drawData, (modifiedBase64Image) => {
      // Update a-plane texture with the modified base64 image
      const aPlane = document.querySelector(this.aPlaneId);
      aPlane.setAttribute('src', '');
      aPlane.setAttribute('src', modifiedBase64Image);
    });
  }
}

export default ImageProcessor;
